function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#721c24",
      strokeWidth: 0.5
    },
    d: "M 23.691406 19.050781 L 13.847656 2.722656 C 13.457031 2.082031 12.75 1.679688 12 1.679688 C 11.25 1.679688 10.542969 2.082031 10.152344 2.722656 L 0.308594 19.050781 C -0.0898438 19.714844 -0.105469 20.546875 0.277344 21.222656 C 0.660156 21.898438 1.378906 22.320312 2.15625 22.320312 L 21.84375 22.320312 C 22.621094 22.320312 23.339844 21.898438 23.722656 21.222656 C 24.101562 20.546875 24.089844 19.714844 23.691406 19.050781 Z M 22.359375 20.453125 C 22.257812 20.640625 22.058594 20.757812 21.84375 20.757812 L 2.15625 20.757812 C 1.941406 20.757812 1.742188 20.640625 1.640625 20.453125 C 1.535156 20.269531 1.535156 20.039062 1.648438 19.855469 L 11.492188 3.53125 C 11.597656 3.351562 11.792969 3.242188 12 3.242188 C 12.207031 3.242188 12.402344 3.351562 12.507812 3.53125 L 22.351562 19.855469 C 22.464844 20.039062 22.464844 20.269531 22.359375 20.453125 Z M 22.359375 20.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#721c24",
      strokeWidth: 0.5
    },
    d: "M 12.007812 8.109375 C 11.414062 8.109375 10.949219 8.429688 10.949219 8.992188 C 10.949219 10.71875 11.152344 13.199219 11.152344 14.921875 C 11.152344 15.371094 11.542969 15.5625 12.007812 15.5625 C 12.355469 15.5625 12.847656 15.371094 12.847656 14.921875 C 12.847656 13.199219 13.050781 10.71875 13.050781 8.992188 C 13.050781 8.429688 12.574219 8.109375 12.007812 8.109375 Z M 12.007812 8.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#721c24",
      strokeWidth: 1.5,
      fillRule: "nonzero",
      fill: "#9F6A2C",
      fillOpacity: 0.5
    },
    d: "M 12.023438 16.5625 C 11.382812 16.5625 10.90625 17.070312 10.90625 17.675781 C 10.90625 18.273438 11.382812 18.792969 12.023438 18.792969 C 12.617188 18.792969 13.125 18.273438 13.125 17.675781 C 13.125 17.070312 12.617188 16.5625 12.023438 16.5625 Z M 12.023438 16.5625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.a394db9f0eb54d816cf99c95189c4585.svg";
export { ForwardRef as ReactComponent };